// src/utils/selectDailyCharacter.js

import seedrandom from 'seedrandom';

export function selectDailyCharacter(characters) {
  // Use the current date to seed the RNG
  const today = new Date();
  const seed =
    today.getUTCFullYear() * 10029 +
    (today.getUTCMonth() + 1) * 100 +
    today.getUTCDate();

  const rng = seedrandom(seed.toString());

  const index = Math.floor(rng() * characters.length);
  console.log(characters[index])
  return characters[index];
}

export function selectYesterdayCharacter(characters) {
  const yesterday = new Date();
  yesterday.setUTCDate(yesterday.getUTCDate() - 1);
  const seed =
    yesterday.getUTCFullYear() * 10029 +
    (yesterday.getUTCMonth() + 1) * 100 +
    yesterday.getUTCDate();

  const rng = seedrandom(seed.toString());

  const index = Math.floor(rng() * characters.length);
  return characters[index];
}
